import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "../MODIFICACIONES/actualizarEspecimen";
import "./detalle.css";
import { Carousel } from "react-bootstrap";

import { agregarQR, decimalAGrado, delEsp, subespecimen, filtrarDatos, Toast } from "../../store/action";
import Menu from "../NAVBAR/menu";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { url } from "../../URL.js";
import CajaDetalle from "./cajaDetalle";
import printFicha from "../../FUNCIONES/printFicha";

export default function Detalle() {
    const userD = useSelector((state) => state.usuario);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [qr, setQr] = useState(null);
    const [especimen, setEspecimen] = useState(null);
    const [prestamoActivo, setPrestamoActivo] = useState([]);
    const [t] = useTranslation("global");
    const { id: ids } = useParams();

    useEffect(() => {
        let isMounted = true;

        axios.get(`${url}especimenRoute/especimen/id?id=${ids}`)
            .then((response) => {
                const num = response.data.especimennumero;
                if (!isMounted) return;
                setEspecimen(response.data);

                if (response.data.prestado) {
                    axios.get(`${url}prestamosRoute/prestamos?id=${num}`)
                        .then((res) => {
                            if (!isMounted) return;
                            setPrestamoActivo(Array.isArray(res.data) ? res.data : []);
                        })
                        .catch((error) => {
                            console.error("Error al cargar préstamo activo:", error);
                            if (!isMounted) return;
                            setPrestamoActivo([]);
                        });
                }
            })
            .catch((error) => {
                console.error("Error al cargar espécimen:", error);
                if (!isMounted) return;
                setEspecimen(null);
            });

        return () => {
            isMounted = false;
            setEspecimen(null);
        };
    }, [ids]);

    const coordenadas = decimalAGrado(especimen?.coordlat, especimen?.coordlong);

    function agregarqr(e) {
        e.preventDefault();
        const idespecimen = especimen?.especimennumero;
        if (!idespecimen) return;

        setQr(1);
        dispatch(agregarQR(idespecimen));
        Toast.fire({
            icon: "success",
            title: "QR generado con éxito!"
        });
    }

    function eliminaEspecimen(e) {
        Swal.fire({
            title: t("ELIMINAESP") + " " + subespecimen(e),
            toast: true,
            position: "top-end",
            showDenyButton: true,
            confirmButtonText: t("ELI"),
            denyButtonText: t("CAN")
        }).then((result) => {
            if (result.isConfirmed) {
                delEsp(e);
                dispatch(filtrarDatos({ parametro: "limpiar" }));
                navigate("/home/");
            }
        });
    }

    function abririmagen(el) {
        Swal.fire({
            imageUrl: `${el.length > 40 ? el : `${url}getImg/` + el}`,
            imageHeight: 300,
            backdrop: `
    rgba(80, 77, 77, 0.70)
    no-repeat
        `
        });
    }

    async function abrirPrestamo() {
        const prestamo = prestamoActivo?.[0];
        if (!prestamo) {
            Toast.fire({ icon: "info", title: "No hay préstamo activo para mostrar." });
            return;
        }

        const result = await Swal.fire({
            title: t("LOAN_TITLE"),
            html:
                `<p>${t("LOAN_BY")} ${prestamo.emisor}</p>` +
                `<p>${t("RESEARCHER")} ${prestamo.investigador}</p>` +
                `<p>${t("INSTITUTION")} ${prestamo.institucion != null ? prestamo.institucion : t("UNDEFINED")}</p>` +
                `<p>${t("SPECIMEN_NUM")} ${prestamo.numeroespecimen ? prestamo.numeroespecimen.map((el) => subespecimen(el.toString())).toString() : ""}</p>` +
                `<p>${t("LOAN_DATE")} ${prestamo.fechaprestamo}</p>` +
                `<p>${t("EST_RETURN_DATE")} ${prestamo.fechadevolucionest}</p>` +
                `<p>${t("COMMENT")} ${prestamo.comentarios != null ? prestamo.comentarios : t("NO_COMMENTS")}</p>`,
            showCloseButton: true,
            showDenyButton: true,
            denyButtonText: t("BACK"),
            confirmButtonText: t("GO_TO_LOANS")
        });

        if (result.isConfirmed) {
            navigate("/home/prestamos");
        }
    }
    console.log(especimen)
    return (
        <div className="container34">
            <div>
                <Menu activo={0} />
            </div>
            <div className="contenido34">
                <div className="cabecera">
                    <div className="vuelve">
                        <Link to={location.state?.from || "/home/"} className="limpiar">{t("VOLVER")}</Link>
                    </div>

                    <div className="a">
                        {t("DETALLE")} {especimen ? subespecimen(especimen?.especimennumero) : ""}
                    </div>
                    {
                        userD.nivel <= 2 ?
                            <div className="vuelve2">
                                <h6 onClick={() => printFicha(especimen, "e")} className="limpiar">{t("IMPFICHA")} </h6>
                                <a className="limpiar" onClick={() => eliminaEspecimen(especimen?.especimennumero)}>{t("ELIMINAESP")}</a>
                            </div>
                            : null
                    }

                </div>
                <div className="cuerpo">
                    <div className="col1-detalle">
                        <div className="info1">

                            <label className="colu1"> {t("GENRE")}:</label>

                            <h6 className="datosCur2">{especimen?.genero ? especimen.genero : t("NO_SPECIFIED")}</h6>

                        </div>

                        <div className="info1">
                            <label className="colu1" > {t("SPECIES")}:</label>

                            <h6 className='datosCur2'>{especimen?.especie ? especimen.especie : t("NO_SPECIFIED")}</h6>
                        </div>
                        <div className="info1">
                            <label className="colu1" > {t("BOCHON")}:</label>

                            <h6 className='datosCur2'>{especimen?.bochonnumero ? <Link to={`/home/bochon/${especimen.bochonnumero}`} className="limpiar">{especimen.bochonnumero}</Link> : t("NO_SPECIFIED")}</h6>
                        </div>

                        <CajaDetalle tipo='filo' elementos={especimen?.posicionfilo}
                        />
                        <CajaDetalle tipo='esqueletal' elementos={especimen?.partesesqueletales}
                        />



                    </div>
                    <div className="col2">
                        <div className="info1">
                            <label >{t("PERIODO")}:</label>
                            <h6 className='datosCur'>{especimen?.periodo}</h6>
                        </div>
                        <div className='info1'>
                            <label >{t("EPOCA")}:</label>
                            <h6 className='datosCur'>{especimen?.epoca}</h6>

                        </div>
                        <div className='info1'>
                            <label >{t("PISO")}:</label>
                            <h6 className='datosCur'>{especimen?.piso}</h6>
                        </div>
                        <div className='info1'>
                            <label >{t("CUENCA")}:</label>
                            <h6 className='datosCur'>{especimen?.cuenca}</h6>
                        </div>
                        <div className='info1'>
                            <label >{t("TRAINING")}:</label>
                            <h6 className='datosCur'>{especimen?.formacion}</h6>
                        </div>

                        <div className='info1'>
                            <label >{t("MIEMBRO")}:</label>
                            <h6 className='datosCur'>{especimen?.miembro}</h6>
                        </div>
                        <div className='info1'>
                            <label >{t("LOCALIDAD")}:</label>
                            <h6 className='datosCur'>{especimen?.localidad}</h6>
                        </div>
                        <div className='info1'>
                            <label >{t("CAMPAIGN")}:</label>
                            <h6 className='datosCur'>{especimen?.campana}</h6>
                        </div>
                        <div className='info1'>
                            <label >{t("FECHACAM")}:</label>
                            <h6 className='datosCur'>{especimen?.fechadescubrimiento}</h6>

                        </div>
                        <div className='info1'>
                            <label >{t("FIELD")}:</label>
                            <h6 className='datosCur'>{especimen?.nrocampo}</h6>


                        </div>

                    </div>
                    <div className="col1">

                        <div className="mostradorDetalle-cord">
                            <div className="cabeza">
                                <label className="lab">{t("COOR")}</label>


                            </div>
                            {coordenadas?.latitud.gra > 0 ? <div className='info1C'>
                                {coordenadas?.latitud.completa}
                                <br></br>                           {coordenadas?.longitud.completa}
                            </div> : <div className='info1C'>
                                {t("MAPSNO")}
                            </div>}

                        </div>
                        {coordenadas?.latitud.gra > 0 ? <a className="base1D" href={"https://www.google.com/maps/place/" + especimen?.coordlat + "," + especimen?.coordlong} target="_blank" rel="noopener noreferrer">
                            <h6 className="h67"> {t("MAPS")}  </h6>
                        </a> : null}
                        <div className="info111">
                            <label >{t("DISCOVERER")}:</label>
                            <h6 className="datosCur">{especimen?.descubridor}</h6>

                        </div>
                        <div className="info111">
                            <label >{t("PREPARADOR")}:</label>
                            <h6 className="datosCur">{especimen?.preparador}</h6>
                        </div>
                        <div className="info111">
                            <label >{t("FECHAPRE")}:</label>
                            <h6 className="datosCur">{especimen?.preparacionfecha}</h6>
                        </div >
                        <div className="info111">
                            <label >{t("FRAGMENTOS")}:</label>
                            <h6 className="datosCur">{especimen?.cantidadfrag}</h6>
                        </div>
                        <div className="info1coment">
                            <label >{t("COMENT")}:</label>
                            <textarea type="text" className="textar" name="comentario" defaultValue={especimen?.comentario} />
                        </div>


                        {
                            especimen?.prestado && userD.nivel < 3 ?
                                <div className="en-prestamo" onClick={abrirPrestamo}>{t("ONLOAN")}</div> : null

                        }

                    </div>
                    <div className="col4-detalle">

                        <div className="info111">
                            <label >{t("PUBLICA")}:</label>

                            {
                                especimen?.pdf?.length > 0 ?
                                    especimen?.pdf.map((el, index) => {
                                        return <a key={`${el}-${index}`} href={`${url}getpdf/` + el} target="_blank" rel="noopener noreferrer" className="caca326">{el.length > 35 ? el.slice(0, 25) + "...pdf" : el}</a>;
                                    }) : <h6 className="datosCur">{t("NOPDF")}</h6>
                            }

                        </div>
                        <div className="info111">
                            <label >{t("HOLOTIPO")}:</label>
                            <h6 className="datosCur">{especimen?.holotipo ? especimen.holotipo.toUpperCase() : t("NO_SPECIFIED")}</h6>
                        </div>
                        <div className="info111">
                            <label >{t("TALLER")}:</label>
                            <h6 className="datosCur">{especimen?.extra1 ? especimen.extra1.toUpperCase() : t("NO")}</h6>
                        </div>
                        <div className="info111">
                            <label >{t("CTSCAN")}:</label>
                            <h6 className="datosCur">{especimen?.extra2 ? especimen.extra2.toUpperCase() : t("NO")}</h6>
                        </div>
                        <div className="info111">
                            <label >{t("CHISTO")}:</label>
                            <h6 className="datosCur">{especimen?.extra3 ? especimen.extra3.toUpperCase() : t("NO")}</h6>
                        </div>
                        <div className="info111">
                            <label >{t("ONPREP")}:</label>
                            <h6 className='datosCur'>{especimen?.extra4 == "Sin Datos" || !especimen?.extra4 ? t("NO") : especimen.extra4?.toUpperCase()}</h6>
                        </div>
                        <div className="info-armario">
                            <div className="info3-detalle1">

                                <div className="cabeza5-detalle1">
                                    <h6 className="datos66">{t("ARMARIO")} {especimen?.armario1}</h6>

                                </div>
                                <div className="estante-detalle">
                                    <h6 className="datos">{t("ESTANTE") + " " + especimen?.estante1desde + " " + t("UNTIL").toLowerCase() + " " + especimen?.estante1hasta} </h6>

                                </div>
                            </div>
                            <div className="info3-detalle1">
                                <div className="cabeza5-detalle1">
                                    <h6 className="datos66">{t("ARMARIO")} {especimen?.armario2}</h6>
                                </div>
                                <div className="estante-detalle">
                                    <h6 className="datos">{t("ESTANTE")} {especimen?.estante2desde} {t("UNTIL").toLowerCase()} {especimen?.estante2hasta} </h6>

                                </div>
                            </div>
                        </div>
                        {
                            especimen?.imagen?.length > 0 ?
                                <div className="info3-imagen-detalle">
                                    <div className="cabeza">
                                        <label className="lab">{t("IMAGENES")}</label>
                                    </div>
                                    <Carousel>
                                        {especimen?.imagen?.map((el, index) => {
                                            return <Carousel.Item key={`${el}-${index}`}>
                                                {
                                                    el.length < 100 ?
                                                        <img
                                                            onClick={() => abririmagen(el)}
                                                            src={`${url}getImg/` + el}
                                                            alt="banner"
                                                            className="foto"
                                                        />
                                                        :
                                                        <img
                                                            onClick={() => abririmagen(el)}
                                                            src={el}
                                                            alt="banner"
                                                            className="foto"
                                                        />
                                                }

                                            </Carousel.Item>;
                                        })}
                                    </Carousel>

                                </div>
                                :
                                <div className="info3-imagen-detalle2">
                                    <div className="cabeza">
                                        <label className="lab">{t("IMAGENES")}</label>
                                    </div>
                                    <div className="sin-imagen">{t("NOIMG")}</div>

                                </div>

                        }
                    </div>
                </div>
                <div className="pie">
                    {
                        userD.nivel >= 3 ? null :
                            <Link className="pie2" to={`/modificar/${especimen?.especimennumero}`}>
                                {t("MODIF")}
                            </Link>
                    }
                </div>
            </div>
        </div>
    );
}




